import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type {
  ISoporteTicket,
  ISoporteNovedad,
  ISoporteEstadisticas
} from '@/modules/Soporte/interfaces'

// Endpoints: /api/v1/support/tickets/*
// list/search/view/create existen por BaseService; el resto se agrega custom.
export class SoporteTicketService extends BaseService<ISoporteTicket> {
  constructor () {
    super({ baseUrl: 'support/tickets/' })
  }

  async novedades (soptId: number): Promise<AxiosResponse<IResponseApi<ISoporteNovedad[]>>> {
    return this.http.get<IResponseApi<ISoporteNovedad[]>>(`/novedades/${soptId}`).catch(this.errorHandle)
  }

  async agregarNovedad (
    soptId: number,
    payload: { observacion?: string, estadoNuevo?: string, tipo?: string }
  ): Promise<AxiosResponse<IResponseApi<{ ticket: ISoporteTicket, novedad: ISoporteNovedad }>>> {
    return this.http.post<IResponseApi<{ ticket: ISoporteTicket, novedad: ISoporteNovedad }>>(
      `/novedad/${soptId}`,
      payload
    ).catch(this.errorHandle)
  }

  async calificar (
    soptId: number,
    payload: { calificacion: number, comentario?: string }
  ): Promise<AxiosResponse<IResponseApi<ISoporteTicket>>> {
    return this.http.post<IResponseApi<ISoporteTicket>>(`/calificar/${soptId}`, payload).catch(this.errorHandle)
  }

  async estadisticas (
    params?: { desde?: string, hasta?: string }
  ): Promise<AxiosResponse<IResponseApi<ISoporteEstadisticas>>> {
    return this.http.get<IResponseApi<ISoporteEstadisticas>>('/estadisticas', { params }).catch(this.errorHandle)
  }
}
